import Vue from "vue";

export const ProductBrandEventBus = new Vue();
